var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MeetingType } from '@web/components/Filters/Elements/MeetingType';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { getDisplayDuration } from '@web/components/layout/WidgetTooltips/ConsistencyOfAttendanceInMeetsTooltip';
import { MeetingAttendanceByDurationChart } from '@web/components/PerformanceReview/Employee/Sections/Schedule&Attendance/MeetingAttendanceByDurationChart';
import { MEETING_ATTENDANCE_CONFIG } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { navigateFromPeriodChartBarClick } from '@web/utility/searchMeetingsNavigation';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { formatDuration } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
export var ConsistencyOfAttendanceInMeets = function (_a) {
    var _b;
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _c = trpc.consistencyOfAttendanceInMeets.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }, {
        enabled: Boolean(userId)
    }), attendanceData = _c.data, isLoading = _c.isLoading, refetch = _c.refetch;
    if (isLoading || !attendanceData) {
        return _jsx(Loading, {});
    }
    var showTeamBars = Boolean((_b = attendanceData.teamPeriods) === null || _b === void 0 ? void 0 : _b.length);
    var handleBarClick = function (chartData, barData, fallbackIndex, stack) {
        navigateFromPeriodChartBarClick({
            navigateTo: navigateTo,
            chartData: chartData,
            barData: barData,
            fallbackIndex: fallbackIndex,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: userId,
            orgUnitId: orgUnitId,
            meetingType: MeetingType.RECURRING,
            stack: stack
        });
    };
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.consistencyOfAttendanceInMeets'), description: t('widgetTitleDescriptions.scheduleAndAttendance.consistencyOfAttendanceInMeets'), insightType: InsightTypeEnum.consistencyOfAttendanceInMeets, insightsData: attendanceData, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.consistencyOfAttendanceInMeets'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var teamByPeriod, attendedLabel, missedLabel;
                        var _a, _b, _c;
                        return __generator(this, function (_d) {
                            teamByPeriod = new Map((_b = (_a = attendanceData.teamPeriods) === null || _a === void 0 ? void 0 : _a.map(function (teamPeriod) { return [
                                teamPeriod.period,
                                teamPeriod
                            ]; })) !== null && _b !== void 0 ? _b : []);
                            attendedLabel = t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.attendedMeetings');
                            missedLabel = t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.missedMeetings');
                            return [2 /*return*/, ((_c = attendanceData.periods) !== null && _c !== void 0 ? _c : []).flatMap(function (period) {
                                    var _a;
                                    var teamPeriod = teamByPeriod.get(period.period);
                                    var teamColumns = showTeamBars && teamPeriod
                                        ? (_a = {},
                                            _a["".concat(t('export.teamAverage'), " ").concat(attendedLabel)] = formatDuration(getDisplayDuration(teamPeriod.teamAverageAttended), 'seconds'),
                                            _a["".concat(t('export.teamAverage'), " ").concat(missedLabel)] = formatDuration(getDisplayDuration(teamPeriod.teamAverageSkipped), 'seconds'),
                                            _a) : {};
                                    return period.meetings.map(function (meeting) {
                                        var _a;
                                        return (__assign((_a = {}, _a[t('filters.period')] = period.period, _a.Attendance = meeting.attendance ? attendedLabel : missedLabel, _a.Title = meeting.title, _a[t('app.apps.searchMeetings.filters.duration')] = formatDuration(getDisplayDuration(meeting.durationSeconds), 'seconds'), _a), teamColumns));
                                    });
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(attendanceData) }) }), _jsx(MeetingAttendanceByDurationChart, { data: attendanceData, chartConfig: MEETING_ATTENDANCE_CONFIG, dateFrom: dateFrom, dateTo: dateTo, negativeLegendColor: "bg-widgetRed-500", teamPeriods: showTeamBars ? attendanceData.teamPeriods : undefined, teamStripeConfig: showTeamBars
                    ? {
                        patternIdPrefix: InsightTypeEnum.consistencyOfAttendanceInMeets,
                        attendedColor: MEETING_ATTENDANCE_CONFIG.attended.teamChartColor,
                        skippedColor: MEETING_ATTENDANCE_CONFIG.missed.teamChartColor
                    }
                    : undefined, onPeriodBarClick: handleBarClick })] })));
};
